import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import ServiceImplementationPage from '@src/pages/Services/Implementation';

export const Route = createLazyFileRoute('/services/implementation')({
  component: ServiceImplementationPageWithLayout,
});

function ServiceImplementationPageWithLayout() {
  return (
    <DefaultLayout>
      <ServiceImplementationPage />
    </DefaultLayout>
  );
}
